const CompletionProgressBar = ({
  title = "",
  subtitle = "",
  progress = 0,
  color = "bg-green-500",
}) => {
  return (
    <div className="bg-white w-full">
      {title && <h3 className="text-lg font-semibold">{title}</h3>}

      {subtitle && <p className="text-sm text-gray-500 mb-8">{subtitle}</p>}

      <div className="w-full bg-gray-200 rounded-full h-3 ">
        <div
          className={`${color} h-3 rounded-full transition-all duration-500 relative`}
          style={{ width: `${progress}%` }}
        >
          <div className={`h-4 w-4 rotate-45 absolute bg-blue-300 ${progress > 0 ? "right-1" : "left-1" } -top-5`}></div>
          <p className={`text-center text-sm font-medium absolute -top-8 ${progress > 0 ? "-right-1" : ""} bg-blue-300 px-2 py-1 z-1 rounded-md`}>
            {progress}%
          </p>
        </div>
      </div>

      {/* Percentage */}
    </div>
  );
};

export default CompletionProgressBar;
